import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchCustomPlanPricing,
  deleteCustomPlanPricing,
  updateCustomPlanPricing,
} from '../actions/customPlans';
import {
  getCustomPlanPricing,
  updateCustomPlanPricingStatusPending,
  deleteCustomPlanPricingStatusPending,
  getLoggedInUser,
} from '../reducers';

const customPlanPricingPage = (DecoratedComponent) => {
  class CustomPlanPricingPage extends Component {
    state = {};

    componentDidMount() {
      this.fetchCustomPlan();
    }

    fetchCustomPlan() {
      const { fetchCustomPlanPricing, planId } = this.props;
      fetchCustomPlanPricing(planId);
    }

    render() {
      const { children, ...props } = this.props;

      return React.createElement(DecoratedComponent, props, children);
    }
  }

  const mapStateToProps = (state, { match }) => {
    const { planId } = match.params;

    return {
      loggedInUser: getLoggedInUser(state),
      planId,
      customPlanPricing: getCustomPlanPricing(state, planId),
      isPendingUpdate: updateCustomPlanPricingStatusPending(state),
      isPendingDelete: deleteCustomPlanPricingStatusPending(state),
    };
  };

  const mapDispatchToProps = {
    fetchCustomPlanPricing,
    deleteCustomPlanPricing,
    updateCustomPlanPricing,
  };

  CustomPlanPricingPage = connect(
    mapStateToProps,
    mapDispatchToProps,
  )(CustomPlanPricingPage);

  return CustomPlanPricingPage;
};

export default customPlanPricingPage;
